<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.38965 18.8984L15.3896 12.8984L9.38965 6.89844"
      stroke="currentColor"
      stroke-width="1.17707"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
